import { render, staticRenderFns } from "./TrialCompleteOwner.vue?vue&type=template&id=5b332421&scoped=true&"
import script from "./TrialCompleteOwner.vue?vue&type=script&lang=js&"
export * from "./TrialCompleteOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b332421",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b332421')) {
      api.createRecord('5b332421', component.options)
    } else {
      api.reload('5b332421', component.options)
    }
    module.hot.accept("./TrialCompleteOwner.vue?vue&type=template&id=5b332421&scoped=true&", function () {
      api.rerender('5b332421', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/newProject/TrialCompleteOwner.vue"
export default component.exports